/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebApiServicesDataTransferObjectsGroupServiceAddBulkPayment
 */
export interface WebApiServicesDataTransferObjectsGroupServiceAddBulkPayment {
    /**
     * 
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsGroupServiceAddBulkPayment
     */
    memberUniqueId?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof WebApiServicesDataTransferObjectsGroupServiceAddBulkPayment
     */
    paymentDate?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiServicesDataTransferObjectsGroupServiceAddBulkPayment
     */
    amount?: number;
}

/**
 * Check if a given object implements the WebApiServicesDataTransferObjectsGroupServiceAddBulkPayment interface.
 */
export function instanceOfWebApiServicesDataTransferObjectsGroupServiceAddBulkPayment(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiServicesDataTransferObjectsGroupServiceAddBulkPaymentFromJSON(json: any): WebApiServicesDataTransferObjectsGroupServiceAddBulkPayment {
    return WebApiServicesDataTransferObjectsGroupServiceAddBulkPaymentFromJSONTyped(json, false);
}

export function WebApiServicesDataTransferObjectsGroupServiceAddBulkPaymentFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiServicesDataTransferObjectsGroupServiceAddBulkPayment {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'memberUniqueId': !exists(json, 'memberUniqueId') ? undefined : json['memberUniqueId'],
        'paymentDate': !exists(json, 'paymentDate') ? undefined : (json['paymentDate'] === null ? null : new Date(json['paymentDate'])),
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
    };
}

export function WebApiServicesDataTransferObjectsGroupServiceAddBulkPaymentToJSON(value?: WebApiServicesDataTransferObjectsGroupServiceAddBulkPayment | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'memberUniqueId': value.memberUniqueId,
        'paymentDate': value.paymentDate === undefined ? undefined : (value.paymentDate === null ? null : value.paymentDate.toISOString()),
        'amount': value.amount,
    };
}

